import React from 'react';
import LeafletMapContain from '../../Componant/Maps/Leafletmap';

const LeafletMap = () => {
  return (
    <div className='page-body'>
      <LeafletMapContain />
    </div>
  );
};

export default LeafletMap;
